export default __webpack_public_path__ + "static/media/char_body_prem_002.94ebf985.png";